/**
 * Ciclo de vida do arquivo de um anexo, espelhando o ms-pedidos.
 *
 * Anexos gerados localmente (comandas, nota não fiscal, upload) já nascem `disponivel`.
 * A NF-e é assíncrona: o anexo aparece no pedido em `processando` e só ganha arquivo
 * quando a SEFAZ responde pelo webhook.
 */
export enum StatusAnexoPedido {
    "processando" = "processando",
    "disponivel" = "disponivel",
    "rejeitado" = "rejeitado",
    "cancelado" = "cancelado",
}

export enum StatusAnexoDescricao {
    "processando" = "Aguardando autorização da SEFAZ",
    "disponivel" = "Disponível",
    "rejeitado" = "Rejeitado pela SEFAZ",
    "cancelado" = "Cancelado",
}
